// usersData.js
export const usersData = {
  wahaj: {
    slug: "wahaj",
    name: "Wahaj Ahmed",
    image: "/images/users/wahaj4.jpg",
    title: "CPA (Canada) | FCCA (UK) I CA (UAE)",
    position: "Founder & CEO — Scan Global",
    email: "wahaj@scanglobal.ca",
    website: "www.scanglobal.me",
    description:
      "Dedicated to empowering high-net-worth individuals, entrepreneurs, and growth-focused businesses, Scan Global Holdings helps clients scale, expand, and optimize their global investments through its network of firms specializing in business advisory, finance, and real estate advisory.",
    about: [
      {
        content: [
          "Based between Dubai and Toronto for over two decades, I bring more than 25 years of experience gained from Fortune 500 companies and top-tier global advisory firms. I currently serve as CEO and Founder of Scan Global Holdings and its network of firms, advising clients on strategic growth, capital deployment, and cross-border investments.",
        ],
      },
    ],
    locations: [
      {
        country: "CANADA",
        phone: "+1 905-379-6197",
        address: "Office 418, 600 Dixon Rd, Toronto, ON M9W 1J1",
      },
      {
        country: "UAE",
        phone: "+971 58-569-6197",
        address: "Office 805, Donna Towers, Dubai Silicon Oasis, Dubai",
      },
      {
        country: "USA",
        address:
          "3 World Trade Center, 175 Greenwich Street, New York, NY 10007",
      },
      {
        country: "UNITED KINGDOM",
        address:
          "Canary Wharf, 39th Floor, One Canada Square, London E14 5AB, United Kingdom",
      },
    ],
    linkedin: "https://www.linkedin.com/in/wahaja/",
    value: "https://scanglobal.me//wahaj",
  },

  bhuvan: {
    slug: "bhuvan",
    name: "Bhuvan Zambad",
    image: "/images/users/bhuvan.jpg",
    title: "",
    position: "Investment Consultant",
    email: "bhuvan@scanglobal.me",
    website: "www.scanglobal.me",
    locations: [
      {
        phone: "+971 58 814 0266",
      },
    ],
    about: [
      {
        content: [
          "I help investors invest smarter in Dubai. Before real estate, my world was finance, data, and investment analysis—building models, studying cycles, and spotting patterns others missed. Real estate, however, was something I grew up around, from construction sites to land deals, long before it became my own calling. I saw too many investors buying hype instead of strategy, overwhelmed by options but lacking clarity. So I built a data-driven advisory focused on numbers over narratives, tailored plans over cookie-cutter pitches, and end-to-end support beyond the sale. This isn’t about selling projects, it’s about aligning property decisions with long-term financial goals, backed by facts, transparency, and the same discipline I’d apply to my own capital.",
        ],
      },
    ],

    value: "https://scanglobal.me//bhuvan",
    linkedin: "https://www.linkedin.com/in/bhuvanzambad7/",
    instagram: "https://www.instagram.com/investwithbhuvan/",
  },

  maricel: {
    slug: "maricel",
    name: "Maricel Golzalvo",
    image: "/images/users/maricel.jpg",
    title: "",
    position: "Senior Investment Consultant",
    email: "maricel@scanglobal.me",
    website: "www.scanglobal.me",
    description: "",
    locations: [
      {
        phone: "+971 52 672 2323",
      },
    ],
    about: [
      {
        content: [
          "Hi, I’m Maricel Gonzalvo",
          "Business Development Consultant | Real Estate Investment | Financial Services",
          "I work with growth-driven organizations and investors to identify, structure, and execute opportunities across financial services and real estate with a focus on long-term value creation.",
        ],
      },
      {
        title: "Scan Global Holdings",
        content: [
          "Collaborate with organizations and investors to identify, structure, and execute growth opportunities.",
        ],
      },
      {
        title: "What I Do",
        list: [
          "Drive strategic business development and growth initiatives",
          "Identify high-growth, strategically aligned investment opportunities",
          "Facilitate market entry and expansion",
          "Leverage data and market insight to inform decisions",
        ],
      },
      {
        title: "How I Add Value",
        list: [
          "Real Estate Investment Advisory: Structuring assets within broader portfolio strategies",
          "Financial Services Expertise: Risk-aware, performance-driven advisory (10+ years experience)",
          "Relationship-Led Execution: Trusted engagement for efficient deal outcomes",
        ],
      },
      {
        title: "Background",
        list: [
          "10+ years in financial services, advisory, and business development",
          "Expertise in financial analysis, due diligence, and deal coordination",
          "Strong investor and partner relationship management",
        ],
      },
      {
        title: "Areas of Specialization",
        list: [
          "Business Development",
          "M&A",
          "Strategic Partnerships",
          "Financial Services",
          "Real Estate Investment",
          "Cross-border Opportunities",
        ],
      },
    ],

    linkedin: "https://www.linkedin.com/in/maricel-gonzalvo9123/",
    value: "https://scanglobal.me//maricel",
  },

  rabia: {
    slug: "rabia",
    name: "Rabia Sajid",
    image: "/images/users/user5.jpg",
    title: "",
    position: "senior investment consultant",
    email: "rabia@scanglobal.me",
    website: "www.scanglobal.me",
    locations: [
      {
        phone: "+971 58 971 8866",
      },
    ],
    about: [
      {
        content: [
          "I am Rabia Sajid, an Off-Plan Property Consultant with proven experience in successfully closing off-plan property deals. I also have strong expertise in the secondary market, helping clients buy and sell ready properties with confidence. My focus is on guiding investors and end-users with the right market insights, transparent advice, and result-driven strategies",
        ],
      },
    ],

    linkedin: "https://www.linkedin.com/in/rabia-sajid-5354b3214/",
    value: "https://scanglobal.me//rabia",
  },

  lysann: {
    slug: "lysann",
    name: "Lysann Abi Nader",
    image: "/images/users/Lysann.jpg",
    title: "",
    position: "Senior Investment Consultant",
    email: "lysann@scanglobal.me",
    website: "www.scanglobal.me",
    description: "",
    locations: [
      {
        phone: "+971 50 153 0855",
      },
    ],
    about: [
      {
        content: [
          "Experienced in Client Engagement with a focus on building meaningful relationships and delivering exceptional client experiences. Specializes in understanding client needs, coordinating solutions, and ensuring smooth communication throughout every stage of engagement.",

          "Committed to maintaining high service standards, fostering long-term relationships, and supporting clients with professionalism, responsiveness, and care.",
        ],
      },
    ],

    linkedin: "",
    value: "https://scanglobal.me//lysann",
  },

  jennifer: {
    slug: "jennifer",
    name: "Jennifer Harding",
    image: "/images/users/Jennifer.jpg",
    title: "",
    position: "Creative Director",
    email: "jennifer@scanglobal.me",
    website: "www.scanglobal.me",
    description: "",
    locations: [
      {
        phone: " +971 58 561 3296",
      },
    ],
    about: [
      {
        content: [
          "I am a Creative Director at SGR, where I lead the creative vision across real estate, branding, spatial storytelling, and market positioning. In this full-time role, I translate complex developments and concepts into clear, compelling narratives- bridging design, strategy, and execution to elevate how projects are experienced, communicated, and brought to life.",
        ],
      },
    ],

    linkedin: "https://www.linkedin.com/in/jennifer-harding-517596327/",
    value: "https://scanglobal.me//jennifer",
  },
  nikola: {
    slug: "nikola",
    name: "Nikola Blair",
    image: "/images/users/Nikola.jpg",
    title: "",
    position: "Head of Strategic Partnerships & Communication (UK)",
    email: "Nikola@scanglobal.co.uk",
    website: "www.scanglobal.me",
    description: "",
    locations: [
      {
        phone: "+44 7460 040437",
        address:
          "Canary Wharf, 39th Floor, One Canada Square, London E14 5AB, United Kingdom",
      },
    ],
    about: [
      {
        content: [
          "A senior business strategist with over 35 years of experience across public services, healthcare, government, and corporate partnerships. Specialized in business consulting, SaaS solutions, finance, asset management, and investor-led mergers and acquisitions. Consistently awarded SaaS Senior Sales Business Account Manager across Canada with Intuit’s QuickBooks Online and recognized as a Top Senior Sales Manager in London’s Financial District. Extensive experience leading government reform and public service integration initiatives for the NHS, commissioned by NICE and the UK Care Quality Commission, with a strong focus on strategic partnerships, venture capital, and sustainable growth.",
        ],
      },
    ],

    linkedin: "https://www.linkedin.com/in/nikolablair/",
    value: "https://scanglobal.me//nikola",
  },
};
